import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';
import { EditCompensatoryOff, RemaniningDays } from '../types';
import { REMAINING_DAYS_INITIAL } from '../utils/consts';
import { DaysAvailableNamespace } from '../components/daysAvailable/settings/types';
import { notification, NotificationType } from '@iba-team/portal-react-components/dist';
import i18n from '../i18n';
class DaysAvailable{
  constructor() {
    makeAutoObservable(this);
  }
  profileRemainingDays: RemaniningDays = REMAINING_DAYS_INITIAL;
  isFetchedProfileRemainingDays = false;
  fetchProfileRemainingDays = async (ent?: {userId?: number, list?: number[], date?: Date}) => {
    try{
      this.isFetchedProfileRemainingDays = false;
      this.profileRemainingDays = await apiConfig.daysAvailableService.getRemainingDay(ent);
      setTimeout(()=> {
        this.isFetchedProfileRemainingDays = true;
      },400);
    }
    catch (e) {
      this.isFetchedProfileRemainingDays = false;
    }
  };
  fetchRemainingDaysWithOldApi = async (ent?: {userId?: string, list?: number[], date?: Date}) => {
    return apiConfig.daysAvailableService.getRemainingDaysOldApi(ent);
  };

  fetchRemainingDays = async (ent?: {userId?: number, list?: number[]}) => {
    return apiConfig.daysAvailableService.getRemainingDay(ent);
  };
  fetchRemainingDaysForUser = async (ent?: {userId?: number, list?: number[]}) => {
    return apiConfig.daysAvailableService.getRemainingDaysForUser(ent);
  };
  fetchEditCompensatoryOff = async (data:EditCompensatoryOff ) => {
    return apiConfig.daysAvailableService.editCompensatoryOff(data);
  };
  setCompensatoryOff = (newValue:number) =>{
    this.profileRemainingDays.compensatoryOffBalance = newValue;
  };
  updateUserBalance = async (dto: DaysAvailableNamespace.UpdateBalanceDto) => {
    apiConfig.daysAvailableService.updateUserBalance(dto).then((res) => {
      if(res.ok){
        notification.open({
          type: NotificationType.SUCCESS,
          title: i18n.t('notifications.success'),
          description: i18n.t('availableDays.notifications.updateBalanceDescription')
        });
      }
    }).catch(() => {
      notification.open({
        type: NotificationType.ERROR,
        title: i18n.t('notifications.error'),
        description: i18n.t('notifications.baseErrorDescription')
      });
    });
  };

  getUserBalanceHistory = async (employeeId: number) => {
    return apiConfig.daysAvailableService.getEmployeeBalanceHistory(employeeId);
  };
}

export const DaysAvailableStore = new DaysAvailable();